import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@lib.core/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService extends ErrorHandler {
  private logger: LoggerService;

  constructor() {
    super();
    this.logger = LoggerService.getLoggerService();
  }

  override handleError(error: Error) {
    this.logger.error(error);
  }
}
